import { useQuery } from '@tanstack/react-query'
import { profile, isEmpty } from '@myap/ui-library'
import { getRequest, queryIsEnabled } from '../utils/fetchOperations'
import { PROFILE_AND_REGISTRATION_KEY } from '../components/_common/reactquery'

const useStudentProfileAndRegistrationQuery = ({
  educationPeriodCd,
  studentId,
  skip,
}) => {
  const { apiUrl } = profile()
  return useQuery({
    queryKey: [PROFILE_AND_REGISTRATION_KEY, educationPeriodCd, studentId],
    // staleTime: 3600000,
    staleTime: 1000,
    refetchOnWindowFocus: false,
    enabled: queryIsEnabled(!isEmpty(educationPeriodCd) &&
      !isEmpty(studentId)) &&
      !skip,
    // initialData: {},
    queryFn: async ({ signal }) => {
      const profileAndRegistrationData = await getRequest({
        url: `${apiUrl}/students/registrations/education-periods/${educationPeriodCd}`,
        signal,
      })
      return profileAndRegistrationData
    },
  })
}

export default useStudentProfileAndRegistrationQuery
